"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Icon_1 = __importDefault(require("../Icon/Icon"));
const ShortcutButton = (props) => {
    const addButton = () => {
        if (props.type === 'add-button') {
            return (React.createElement("div", { className: "shortcut-button-add-container" },
                React.createElement("div", { className: "shortcut-button-add-icon" }),
                React.createElement("div", { className: "shortcut-button-add-text" }, props.addText)));
        }
        return null;
    };
    const addButtonContentToRender = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "shortcut-button-content" },
                React.createElement("h3", null, props.title),
                props.text,
                addButton()),
            props.illustration && React.createElement("div", { className: "shortcut-button-illustration" }, props.illustration)));
    };
    const contentToRender = () => {
        return (React.createElement(React.Fragment, null,
            props.illustration && React.createElement("div", { className: "shortcut-button-illustration" }, props.illustration),
            React.createElement("div", { className: "shortcut-button-content" },
                React.createElement("h3", null, props.title),
                props.text),
            props.type !== 'add-button' && React.createElement(Icon_1.default, { icon: "arrow_right" })));
    };
    if (props.type === 'link-external') {
        return (React.createElement("a", { className: 'shortcut-button', href: props.href }, contentToRender()));
    }
    if (props.type === 'link-internal') {
        return (React.createElement(react_router_dom_1.Link, { to: props.href, className: 'shortcut-button' }, contentToRender()));
    }
    if (props.type === 'add-button') {
        return (React.createElement("button", { className: 'shortcut-button shortcut-button-add', onClick: props.onClick, type: "button" }, addButtonContentToRender()));
    }
    if (props.type === 'button') {
        return (React.createElement("button", { className: 'shortcut-button', onClick: props.onClick, type: "button" }, contentToRender()));
    }
    return null;
};
exports.default = ShortcutButton;
//# sourceMappingURL=ShortcutButton.js.map